// Sidebar.jsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../css/usermain.css';
import { faFolderOpen,faUserTie,faCloud,faPause,faCalendarDay,faUserClock,faUserGear,faUsers,faPen,faFilePen  } from '@fortawesome/free-solid-svg-icons';

const ProjectSidebar = ({ isOpen, onClose, project }) => {
    const [tasks, setTasks] = useState([]);
      const [projectRunningMap, setProjectRunningMap] = useState({});
    

 useEffect(() => {
  if (!project || !project.project_id) return;

  const fetchTasks = async () => {
    try {
      const res = await axios.get(
        `/api/tasks.php?project_id=${project.project_id}`
      );
      setTasks(res.data);
    } catch (error) {
      console.error('Error fetching tasks:', error);
    }
  };

  fetchTasks();
}, [project]);
const markAsDone = async (projectId) => {
  // Check if any task in the project is still running
  if (projectRunningMap[projectId]) {
    alert("Cannot close project. A task is currently running in this project.");
    return;
  }

  try {
    const res = await fetch("/api/updateProjectStatus.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({
        action: "update_status",
        project_id: projectId,
        status: "Done",
      }),
    });

    const data = await res.json();
    if (data.success) {
      console.log("Marked as Done");
      window.location.reload();
    } else {
      console.error(data.error);
    }
  } catch (err) {
    console.error("Error updating project status:", err);
  }
};

useEffect(() => {
  const fetchTasks = async () => {
    try {
      const res = await axios.get("/api/tasks.php");
      const tasks = res.data;

      const map = {};

      tasks.forEach(task => {
        const pid = task.project_id;

        // Check if task status is To Do, Doing, or Hold
        if (["To Do", "Doing", "Hold"].includes(task.status)) {
          map[pid] = true;
        }
      });

      setProjectRunningMap(map);
    } catch (error) {
      console.error("Failed to fetch tasks for running status:", error);
    }
  };

  fetchTasks();
}, []);




  return (
    
    <div
      className={`fixed top-0 right-0 h-full w-105 bg-white shadow-lg transition-transform duration-300 z-50 overflow-y-auto max-h-screen scrollbar-hide ${
        isOpen ? 'translate-x-0' : 'translate-x-full'
      }`}
    >
      <div className="flex justify-between items-center p-4 pb-1 ">
        <h2 className="text-lg text-gray-600 font-bold">
          <FontAwesomeIcon icon={faFolderOpen} className="text-yellow-500 mr-1" />
          Project Details 
        </h2>
        <div className='flex gap-2'>
          
        <button onClick={onClose} className="text-gray-500 hover:text-red-600">✕</button>


        </div>
        
      </div>

      <div className="p-4">
        {!project ? (
          <p className="text-gray-400 italic">No project selected</p>
        ) : (
          <>
            <div className="flex gap-2 mb-1">
              <div className="w-full bg-white px-3 py-2 shadow-sm rounded-xs">
                <p className="block text-sm font-medium text-gray-700">
                  <span className="text-sm">
                    <FontAwesomeIcon icon={faFolderOpen} className="text-lg pb-[1px] mr-1 text-yellow-400" />
                    {project.project_id} :
                  </span> {project.name}
                </p>
              </div>
            </div>

            <div className="flex gap-2 mt-2 mb-1">
              <div className="w-[49%] bg-white px-3 py-2 shadow-sm rounded-xs">
                <p className="block text-xs font-medium text-gray-700">
                  <span className="text-xs">
                    <FontAwesomeIcon icon={faUserTie} className="text-sm mr-1 text-red-400" />
                  </span>Client : {project.client}
                </p>
              </div>
              <div
  className="w-[49%] bg-white px-3 py-2 shadow-sm rounded-xs"
  
>
  <p className="block text-xs font-medium text-gray-700">
    <span className="text-xs">
      <FontAwesomeIcon icon={faPause} className="text-sm mr-1 text-yellow-500" />
    </span>
    Status : 
    <span 
    className='px-1 rounded-lg ml-2'
    style={{
    backgroundColor:
      project.status === "Todo"
        ? "#fde68a"
        : project.status === "Doing"
        ? "#bfdbfe"
        : project.status === "Done"
        ? "#bbf7d0"
        : project.status === "Hold"
        ? "#c2c2c2ff"
        : "transparent",
  }}>{project.status}</span>
  </p>
</div>

            </div>
             <div className="flex gap-2 mt-2 mb-1">
              <div className="w-[49%] bg-white px-3 py-2 shadow-sm rounded-xs">
                <p className="block text-xs font-medium text-gray-700">
                  <span className="text-xs">
                    <FontAwesomeIcon icon={faCloud} className="text-xs mr-1 text-blue-200" />
                  </span>Category:  {project.category}
                </p>
              </div>
              <div className="w-[49%] bg-white px-3 py-2 shadow-sm rounded-xs">
                <p className="block text-xs font-medium text-gray-700">
                  <span className="text-xs">
                    <FontAwesomeIcon icon={faCalendarDay } className="text-sm mr-1 text-red-300" />
                  </span>Deadline:   {new Date(project.submisssion_date).toLocaleDateString('en-GB')}
                </p>
              </div>
            </div>
            <div className="flex gap-2 mt-2 mb-1">
              <div className="w-[49%] bg-white px-3 py-2 shadow-sm rounded-xs">
                <p className="block text-xs font-medium text-gray-700">
                  <span className="text-xs">
                    <FontAwesomeIcon icon={faUserClock } className="text-sm mr-1 text-green-500" />
                  </span>Manage By:  {project.assign_to}
                </p>
              </div>
              <div className="w-[49%] bg-white px-3 py-2 shadow-sm rounded-xs">
                <p className="block text-xs font-medium text-gray-700">
                  <span className="text-xs">
                    <FontAwesomeIcon icon={faUserGear} className="text-sm mr-1 text-orange-300" />
                  </span>Assign By:  {project.assign_by}
                </p>
              </div>
            </div>
            <div className="flex gap-2 mt-2 mb-1">
              <div className="w-full bg-white px-3 py-2 shadow-sm rounded-xs">
                <p className="block text-xs font-medium text-gray-700">
                  <span className="text-xs">
                    <FontAwesomeIcon icon={faUsers} className="text-sm mr-1 text-orange-300" />
                  </span>Team Members:  {project.team_members}
                </p>
              </div>
            </div>

            <div className="flex gap-2 mt-2 mb-1">
              <div className="w-full bg-white px-3 py-2 shadow-sm rounded-xs">
                <p className="block text-sm font-medium text-gray-700">
                  <span className="text-lg">
                    <FontAwesomeIcon icon={faPen} className="text-sm mr-1 text-orange-300" />
                  </span>Task:  
                </p>
                {tasks.length === 0 ? (
        <p>No tasks found.</p>
      ) : (
        <div className='border-l border-dotted border-gray-600 ml-5'>
        <table className="  text-sm ">
          <tbody>
            {tasks.map((task) => (
              <tr key={task.id} className="">....
                <td className=" py-1 "><FontAwesomeIcon icon={faFilePen} className='text-red-300 text-xs mx-1'/><span className='font-semibold text-gray-600'>{task.task_name}</span></td>
                <td className=" py-1"><div
                        className="font-medium px-2 ml-3 py-[1px]  rounded-lg text-center cursor-pointer text-[10px]"
                        style={{
                          backgroundColor:
                            task.status === "To Do"
                              ? "#fde68a"
                              : task.status === "Doing"
                              ? "#bfdbfe"
                              : task.status === "Done"
                              ? "#bbf7d0"
                              : task.status === "Hold"
                              ? "#c2c2c2ff"
                              : "transparent",
                        }}
                      >
                        {task.status || "Select Status"}
                      </div></td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      )}
              </div>
            </div>

            
          </>
        )}
      </div>
      <div className=' pl-4 mb-4'>
         {project && project.status !== "Done" && (
          <button
            onClick={() => markAsDone(project.project_id)}
            className=" px-3 py-1 text-xs font-bold rounded text-white bg-red-500 shadow-lg ml-auto"
          >
             Close Project
          </button>
        )}
      </div>
     
    </div>
  );
};

export default ProjectSidebar;
